module.exports = __webpack_public_path__ + "img/South_Lanarkshire.ccc4199b.png";